import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

// Components
import { Container, Row, Col } from 'reactstrap';
import ButtonHeader from 'components/atoms/ButtonHeader';
import Modal from 'components/atoms/Modal';
import ModalServicesList from 'components/molecules/ModalServicesList';
import Price from 'components/atoms/Price';
import SidebarButton from 'components/pages/User/Sidebar/SidebarButton';

// Utils
import { isDiscountValid } from 'utils/promotions';

import './AppointmentFlowHeader.scss';

// Constants
import { APP_FLOW } from 'constants/appFlow';

const ns = 'appointment-flow-header';
const modalNs = 'services-modal';
const { QUICK_APPT } = APP_FLOW;

class AppointmentFlowHeader extends Component {
  constructor(props) {
    super(props);
    this.modal = React.createRef();
  }

  getFinancingOptionMessage() {
    const { isFlexPayEnabled } = this.props;

    // TODO: remove defaultMessage once localization is ready
    return (
      isFlexPayEnabled && (
        <Row>
          <Col className={`${modalNs}__financing-text`}>
            <FormattedMessage
              id="c8.review.financing.options"
              defaultMessage="We offer financing options, talk to your service advisor for details."
            >
              {text => text}
            </FormattedMessage>
          </Col>
        </Row>
      )
    );
  }

  render() {
    const {
      label,
      routeTo,
      services,
      servicesCount,
      totalPrice,
      className,
      gtmUserEventShoppingCart,
      onClick,
      showPrice,
      isLoggedIn,
      firstName,
      lastName,
      hasPromotion,
      backButtonAriaLabel,
      appFlow,
      isDMSAppt
    } = this.props;
    const { discountedPrice, price } = totalPrice;
    const buttonClassName = cn({
      visible: servicesCount > 0
    });
    const displayPrice = showPrice && price > 0;
    const showServicesCart = appFlow !== QUICK_APPT && servicesCount > 0;
    // @TODO: split Cart Modal into its own component
    return (
      <Container className={className}>
        <Modal
          ref={this.modal}
          title={() => {
            return (
              <React.Fragment>
                {displayPrice && (
                  <Row>
                    <Col xs={'6'}>
                      <FormattedMessage id="c8.cart.total.label">
                        {text => text}
                      </FormattedMessage>
                      :
                    </Col>
                    <Col
                      xs={'6'}
                      className={`${modalNs}__col ${modalNs}__col--single-line`}
                    >
                      {hasPromotion &&
                        isDiscountValid(price, discountedPrice) && (
                          <div
                            className={`${modalNs}__service-price ${modalNs}__service-price--promotion mr-2`}
                          >
                            <Price value={price} showZero={true} />
                          </div>
                        )}
                      <div className={`${modalNs}__service-price`}>
                        <Price
                          value={hasPromotion ? discountedPrice : price}
                          showZero={true}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
                {this.getFinancingOptionMessage()}
              </React.Fragment>
            );
          }}
        >
          <ModalServicesList serviceList={services} />
        </Modal>
        <Row>
          <Col xs="6" sm="6">
            {!isDMSAppt && (
              <ButtonHeader
                ariaLabel={backButtonAriaLabel}
                label={label || ''}
                to={routeTo}
                onClick={onClick}
              />
            )}
          </Col>
          <Col xs="6" sm="6" className={`${ns}--right`}>
            {isLoggedIn && (
              <SidebarButton firstName={firstName} lastName={lastName} />
            )}
            {showServicesCart && (
              <FormattedMessage
                id="c8.aria.number.services.selected"
                values={{ servicesCount }}
              >
                {text => (
                  <ButtonHeader
                    className={buttonClassName}
                    label={`${servicesCount}`}
                    type="cart"
                    onClick={() => {
                      gtmUserEventShoppingCart();
                      this.modal.current.setShowModal(true);
                    }}
                    ariaLabel={text}
                  />
                )}
              </FormattedMessage>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

AppointmentFlowHeader.propTypes = {
  className: PropTypes.string,
  firstName: PropTypes.string,
  goTo: PropTypes.func.isRequired,
  gtmUserEventShoppingCart: PropTypes.func.isRequired,
  hasPromotion: PropTypes.bool,
  intl: PropTypes.object,
  isFlexPayEnabled: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  label: PropTypes.string,
  lastName: PropTypes.string,
  onClick: PropTypes.func,
  routeTo: PropTypes.string.isRequired,
  services: PropTypes.array,
  servicesCount: PropTypes.number.isRequired,
  showPrice: PropTypes.bool.isRequired,
  totalPrice: PropTypes.object.isRequired,
  backButtonAriaLabel: PropTypes.string,
  appFlow: PropTypes.string.isRequired,
  isDMSAppt: PropTypes.bool.isRequired
};

AppointmentFlowHeader.defaultProps = {
  services: [],
  onClick: () => {}
};

Container.propTypes = {
  fluid: PropTypes.bool
  // applies .container-fluid class
};

export default AppointmentFlowHeader;



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentFlowHeader/AppointmentFlowHeader.js